import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, Paper, Typography } from '@material-ui/core'
import clsx from 'clsx'

import {
  TicketFeedback,
  TicketMessages,
  ReplyTicket,
  ReopenTicket,
} from './components'
import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

import useFetch from 'hooks/useFetch'

import useStyles from './styles'

const TicketDetails = ({ match }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const { ticketId } = match.params

  const { response, refresh, isLoading } = useFetch(
    service.dponet.tickets.get,
    {
      ticketId: ticketId,
    },
  )

  const {
    response: messagesResponse,
    refresh: messageRefresh,
    isLoading: isLoadingMessage,
  } = useFetch(service.dponet.tickets.showMessages, { ticketId: ticketId })

  const ticket = useMemo(() => response?.data?.ticket, [response])
  const ticketMessages = useMemo(
    () => messagesResponse?.data?.ticketMessages,
    [messagesResponse],
  )

  const shouldPermitReply = useMemo(() => {
    const ticketStatuses = [
      constants.tickets.NEW_STATUS_ID,
      constants.tickets.PENDING_STATUS_ID,
      constants.tickets.REPLIED_STATUS_ID,
      constants.tickets.REOPEN_STATUS_ID,
    ]

    return ticketStatuses.includes(ticket?.status?.id) && ticket?.allowedRespond
  }, [ticket])

  const shouldPermitReopen =
    ticket?.status?.id === constants.tickets.COMPLETED_STATUS_ID &&
    ticket?.permissionReopen

  return (
    <Page title="Detalhes Parecer Técnico">
      <LoadingFeedback open={isLoading || loading} />
      <Container maxWidth={false}>
        <ContentHeader title={`Solicitação ID: ${ticketId}`} />
        <Paper component={Box} elevation={2} mb={4} p={3} display="flex">
          <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" mb={2}>
              <Typography className={classes.boxId}>{ticket?.id}</Typography>
              <Typography
                className={clsx(
                  classes.boxStatus,
                  helpers.tickets.statusLabelColor(ticket?.status?.id, classes),
                )}
              >
                {ticket?.status?.name}
              </Typography>
            </Box>
            <Typography variant="h5">Categoria: {ticket?.title}</Typography>
            <Typography variant="h6">
              Título: {ticket?.subtitle ?? 'Não informado'}
            </Typography>
            <Divider />

            <TicketMessages
              ticketMessages={ticketMessages}
              isLoadingMessage={isLoadingMessage}
            />

            {shouldPermitReply && (
              <ReplyTicket
                refresh={messageRefresh}
                setLoading={setLoading}
                ticketId={ticketId}
              />
            )}

            {shouldPermitReopen && (
              <ReopenTicket ticketId={ticketId} refresh={refresh} />
            )}
          </Box>
        </Paper>

        {!shouldPermitReply && ticket?.allowedRespond && (
          <TicketFeedback
            ticketId={ticketId}
            ticketFeedback={ticket?.ticketFeedback}
            refresh={refresh}
          />
        )}
      </Container>
    </Page>
  )
}

TicketDetails.propTypes = {
  match: PropTypes.object,
}

export default TicketDetails
